/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFashionShowTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFashionShow,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Strut Your Stuff!",
    "Fashion Show Awaits!",
    "Let’s Walk the Runway!",
  ],
  title: "Fashion Show",
  description: "Organize a stylish fashion show.",
  longDescription:
    "Gather your friends for a glamorous fashion show! Choose a date, decide on themes, and plan activities for the event!",
  emoji: "👗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fashion Show",
          emoji: "👗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the fashion show?",
          emoji: "📅",
          completeAction: {
            question: "Decide on themes for the show?",
            description: "What themes should we follow for our fashion show?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What themes should we consider?",
                emoji: "🌈",
                completeAction: {
                  question: "Decide on activities during the show?",
                  description:
                    "What activities should we include during the fashion show?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Showcase Style!",
    outroDescription: "Your fashion show plans are set! Enjoy the runway!",
  },
};
